module.exports = __webpack_public_path__ + "img/attachment.10ea4386.svg";